import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'new-hygiene-check',
  templateUrl: './new-hygiene-check.component.html',
  styleUrls: ['./new-hygiene-check.component.scss']
})
export class NewHygieneCheckComponent {

  constructor( public translate: TranslateService) {
  }
  
}